import React from "react";
import {
  FaSolarPanel,
  FaRobot,
  FaVrCardboard,
  FaMobileAlt,
  FaChartLine,
  FaBrain,
  FaTv,
  FaPaintBrush,
  FaSchool
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Services() {
  const navigate = useNavigate();

  // 🔹 Routes (order must match services array)
  const paths = [
    "/robotics",
    "/vr",
    "/web-app",
    "/automation",
    "/marketing",
    "/solar",
    "/smart-panels",
    "/creative-arts",
    "/school-erp",
  ];

  // 🔹 Services Data
  const services = [
    {
      icon: FaRobot,
      title: "Robotics",
      description:
        "Future-ready STEM learning for Grades 1–10. Turnkey robotics lab setup, 12 structured hands-on sessions per year, teacher training & ready lesson plans.",
      color: "from-blue-400 to-blue-600",
    },
    {
      icon: FaVrCardboard,
      title: "VR Gadgets",
      description:
        "Immersive VR learning for Science, Maths, Social, Biology, Chemistry & Physics aligned to NCERT curriculum (CBSE & State boards).",
      color: "from-purple-400 to-pink-500",
    },
    {
      icon: FaMobileAlt,
      title: "Website & Mobile App Design",
      description:
        "Custom mobile and web apps that integrate technology, performance, and usability for scalable digital growth.",
      color: "from-green-400 to-teal-500",
    },
    {
      icon: FaBrain,
      title: "AI In Education",
      description:
        "Automation that saves teachers’ time with auto-corrected assessments, AI analytics, and skill-based performance dashboards.",
      color: "from-red-400 to-pink-500",
    },
    {
      icon: FaChartLine,
      title: "Digital Marketing",
      description:
        "School branding, positioning, and social media management to increase visibility, enquiries, and admissions.",
      color: "from-indigo-400 to-purple-500",
    },
    {
      icon: FaSolarPanel,
      title: "Solar Installations",
      description:
        "Rooftop solar solutions for educational campuses with net-metering and DISCOM coordination.",
      color: "from-yellow-400 to-orange-500",
    },

    // 🔹 NEW SERVICES
    {
      icon: FaTv,
      title: "Interactive Smart Panels",
      description:
      "Smart classrooms that engage every learner Highlights Touch-enabled digital boards 65” / 75” / 86” Compatible with Google, Microsoft & educational apps Screen mirroring • Annotation • Recording • 4K display",
      color: "from-cyan-400 to-blue-500",
    },
{
  icon: FaPaintBrush,
  title: "Painting & Creative Arts Program",
  description: `
Creativity + confidence for every student

Highlights:
• 12 structured art sessions per year
• Age-appropriate activities (drawing → craft → canvas)
• Teacher training with lesson plans
• Annual art exhibition & certificates
  `,
  color: "from-pink-400 to-rose-500",
},

    {
      icon: FaSchool,
      title: "Customized School ERP",
      description:
      "Your school’s logo • Your school’s dashboard • Your own identity Core Modules Admissions • Students • Attendance • ExamsFees & receipts • Reports • Parent & Teacher app",
      color: "from-emerald-400 to-green-600",
    },
  ];

  return (
    <section
      id="services"
      className="scroll-mt-28 bg-gradient-to-b from-gray-50 to-white text-center
                 pt-6 sm:pt-8 md:pt-10 pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6"
    >
      <div className="max-w-7xl mx-auto">

        {/* 🔹 Heading */}
        <div className="mb-12 sm:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-3 text-gray-900">
            Our Services
          </h2>

          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto mb-6"></div>

          <p className="text-gray-600 max-w-3xl mx-auto text-base leading-relaxed">
            We provide advanced solutions that drive innovation, efficiency,
            and sustainable growth across education and technology.
          </p>
        </div>

        {/* 🔹 Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;

            return (
              <div
                key={index}
                onClick={() => navigate(paths[index])}
                className="
                  cursor-pointer bg-white rounded-2xl shadow-lg
                  p-8 flex flex-col items-center text-left
                  hover:shadow-2xl hover:-translate-y-2
                  transition-all duration-500 ease-in-out
                  border border-gray-100 group min-h-[320px]
                "
              >
                {/* Icon */}
                <div
                  className={`
                    bg-gradient-to-br ${service.color} text-white
                    w-20 h-20 flex items-center justify-center
                    rounded-2xl mb-6
                    transition-all duration-500
                    group-hover:scale-110
                  `}
                >
                  <IconComponent size={34} />
                </div>

                {/* Title */}
                <h3
                  className="
                    text-xl font-semibold mb-3
                    text-gray-900 group-hover:text-blue-600
                    transition-colors duration-300
                  "
                >
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-black-800 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}

export default Services;
